import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Partials/DedicatedShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Partials/DynamicPortfolio.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
